function t(t){return function(){var r=arguments.length>0&&void 0!==arguments[0]?arguments[0]:{},d=r.width?String(r.width):t.defaultWidth;return t.formats[d]||t.formats[t.defaultWidth]}}export{t as default};
